export const m2vMimeTypes = ["video/mpeg"];
